import WIDGETS from './widgets';

export default {
	name: 'support',
	spacing: 2,
	widgets: [{ content: WIDGETS.SUPPORT, breakpoints: { xs: 12 }, lazy_loading: 0 }],
};
